module.exports = __webpack_public_path__ + "static/media/logo-jellyfish-color-standard.5a5d087f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-jellyfish-color-standard.png
// module id = 390
// module chunks = 0